export default "<p>payments works!</p>\n";